module.exports = __webpack_public_path__ + "static/Branded Rock Canyon - Home-51d123ffce0cc0a7694bb6e4169106bf.png";